"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCookiesAndSignOut = exports.deleteAllCookies = void 0;
var sso_1 = require("./sso");
var token_1 = require("./token");
var types_1 = require("./types");
var window_1 = require("./window");
/**
 * Class that handles browser cookies
 * @method read
 * @method write
 * @method erase
 */
var Cookie = /** @class */ (function () {
    function Cookie(prefix) {
        this.prefix = prefix ? "".concat(prefix, "::") : '';
    }
    /**
     * Reads the cookie with name passed as parameter
     * @param name
     * @returns cookie contents
     */
    Cookie.prototype.read = function (name) {
        var nameEQ = "".concat(this.prefix).concat(name, "=");
        var ca = document.cookie.split(';');
        // In case of multiple cookies with the same name, we need to return the first non-empty one.
        var cookie = ca.map(function (c) { return c.trim(); }).find(function (c) { return c.indexOf(nameEQ) > -1 && !!c.substring(nameEQ.length); });
        return cookie ? cookie.substring(nameEQ.length) : '';
    };
    /**
     * Sets a cookie to the browser
     * @param name of cookie
     * @param value of cookie
     * @param days expiration time
     */
    Cookie.prototype.write = function (name, value, days, eraseCurrentGWIDomain) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = ";expires=".concat(date.toUTCString());
        }
        var domain = window_1.UrlManager.getUrlDomainRoot();
        var cookieDomain = domain.includes('localhost') ? '' : "domain=.".concat(domain, ";");
        document.cookie = "".concat(this.prefix).concat(name, "=").concat(value).concat(expires, ";path=/;").concat(cookieDomain, ";SameSite=Lax");
        //TODO: Remove this implementation after deployment of refresh-token. This is used to clear cookies from .globalwebindex.com & from current domain
        if (eraseCurrentGWIDomain) {
            var cookieDomain_1 = "domain=".concat(window.location.hostname, ";");
            document.cookie = "".concat(this.prefix).concat(name, "=").concat(value).concat(expires, ";path=/;").concat(cookieDomain_1, ";SameSite=Lax");
        }
    };
    /**
     * Deletes cookie
     * @param name of cookie to delete
     */
    Cookie.prototype.erase = function (name) {
        this.write(name, '', -1, true);
    };
    return Cookie;
}());
exports.default = Cookie;
/**
 * Deletes of cookies
 */
var deleteAllCookies = function () {
    var cookies = document.cookie.split(';');
    var updatedCookies = cookies.map(function (cookie) {
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        return "".concat(name, "=;expires=-1");
    });
    document.cookie = updatedCookies.join(';');
};
exports.deleteAllCookies = deleteAllCookies;
var clearCookiesAndSignOut = function (environment) {
    var cookie = new Cookie(null);
    var authTokenName = (0, token_1.getTokenCookieName)(types_1.TokenType.Authorization, environment);
    var authMasqueradedTokenName = (0, token_1.getTokenCookieName)(types_1.TokenType.Authorization, environment, true);
    var refreshTokenName = (0, token_1.getTokenCookieName)(types_1.TokenType.Refresh, environment, true);
    cookie.erase('auth_gwi_experimental');
    cookie.erase(authTokenName);
    cookie.erase(refreshTokenName);
    cookie.erase(authMasqueradedTokenName);
    cookie.erase('auth_token');
    (0, sso_1.signout)(environment);
};
exports.clearCookiesAndSignOut = clearCookiesAndSignOut;
